import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { getAccessToken } from 'src/utils/token-service';

interface Flag {
  Id: number;
  Name: string;
  Category: string;
  Priority: string;
  Color: string;
  Tooltips: string;
}

const AgentAssistUI = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [flagsData, setFlagData] = useState<Flag[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData()
  }, [])

  const handleClick = () => {
    console.log('Inside the Greet function');
  }

  const fetchData = async () => {
    setLoading(true);
    try {
      let url = 'https://api-dv.brightspeed.com/genai-agent-assist-rag/agent_assist_flags?ban=3535435&intent=Billing';
      let accessToken = await getAccessToken();
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: url,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await axios.request(config);
      setFlagData(response.data.Flag);
    } catch (error) {
      console.log('Error calling API:', error);
    }
  };


  return (
    <>
      <div className="w-[70%] scale-[0.85] origin-top-left">


        <div className="p-1">
          <div className="grid grid-cols-5 gap-6 items-stretch">

            {/* Left Panel (Flags) */}
            <div className="col-span-1">
              <div className="bg-white shadow p-1 h-full text-sm flex flex-col items-start relative min-h-[30px]">
                {/* Collapse/Expand Button */}
                {!collapsed && (
                  <button
                    onClick={() => setCollapsed(true)}
                    className="absolute top-1 left-1 p-1 hover:bg-gray-200 rounded"
                  >
                    <ChevronDownIcon className="h-4 w-4 text-gray-600" />
                  </button>
                )}

                {/* Placeholder or Actual Content */}
                <div className="w-full h-full flex justify-center items-center">
                  {collapsed ? (
                    <button
                      onClick={() => setCollapsed(false)}
                      className="flex items-center gap-2 text-sm px-2 py-1 rounded"
                    >
                      <ChevronUpIcon className="h-4 w-4 text-gray-600" />
                      <span><strong>Flags</strong></span>
                    </button>
                  ) : (
                    <p className="pt-5 w-full text-center"><strong>Flags</strong></p>
                  )}
                </div>
              </div>

            </div>

            {/* Right Panel */}
            <div className="col-span-3">
              <div className="bg-white shadow p-1 h-full flex flex-col justify-between min-h-[30px]">
                {!collapsed ? (

                  <div className="grid grid-cols-2 gap-2">
                    {/* Buttons Column */}
                    <div className="grid grid-rows-4 gap-2">
                      <button className="bg-red-600 text-white px-4 py-1 text-xs w-full shadow row-span-3">
                        Churn Propensity: High
                      </button>
                      <button className="bg-green-600 text-white px-4 py-1 text-xs w-full shadow row-span-1">
                        Upsell
                      </button>
                    </div>

                    <div className="flex flex-col">
                      {flagsData
                        .filter(
                          (flag) =>
                            flag.Color.toLowerCase() === 'red' &&
                            flag.Category === 'Churn Propensity High'
                        )
                        .map((flag) => (
                          <div key={flag.Id} className="relative group w-full">
                            <input
                              type="text"
                              value={flag.Name}
                              disabled
                              title={flag.Tooltips || ''}
                              className="w-full bg-gray-100 border border-gray-300 rounded px-3 py-2 text-xs pr-8 cursor-not-allowed"
                            />
                            <ChevronDownIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500 pointer-events-none" />
                          </div>
                        ))}


                      {flagsData
                        .filter(
                          (flag) =>
                            flag.Color.toLowerCase() === 'green' &&
                            flag.Category === 'Upsell'
                        )
                        .map((flag) => (
                          <div key={flag.Id} className="relative group w-full">
                            <input
                              type="text"
                              value={flag.Name}
                              disabled
                              title={flag.Tooltips || ''}
                              className="w-full bg-gray-100 border border-gray-300 rounded px-3 py-2 text-xs pr-8 cursor-not-allowed"
                            />
                            <ChevronDownIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500 pointer-events-none" />
                          </div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <p className='text-xs p-3'>Show More...</p>
                )}
              </div>
            </div>

          </div>
        </div>


        <div className="p-1">
          <div className="grid grid-cols-5 gap-6 items-stretch">
            {/* Left Panel (Flags) */}
            <div className="col-span-1">
              <div className="bg-white shadow p-1 h-full flex text-sm flex-col justify-center items-center">
                <p> <strong>Pre Interaction Summary</strong></p>
              </div>
            </div>

            {/* Middle Panel */}
            <div className="col-span-3 space-y-3">
              <div className="col-span-3 space-y-3">
                <div className="bg-white shadow p-1 h-full flex flex-col justify-between">
                  <div className="rounded text-xs text-gray-700 mt-2">
                    <p>
                      Name on account: <strong>Jane Doe
                      </strong></p>
                    <p>
                      Pre Authenticated: <strong>Yes</strong>
                    </p>
                    <p>Intent:<strong>Billing – Bill dispute</strong> </p>

                  </div>

                </div>
              </div>
              <div className="col-span-3 space-y-3">
                <div className="bg-white shadow p-1">
                  <div className="p-1 text-xs mt-2">
                    <h3 className="font-semibold">
                      Customer History Summary:
                    </h3>

                    {/* Scrollable List Container */}
                    <div className="max-h-40 overflow-y-auto pr-2 mt-2">
                      <ul className="list-disc ml-5 text-xs space-y-1">
                        <li>Customer called 6 times in the last 10 days.</li>
                        <li>This issue is regarding a recent price adjustment.</li>
                        <li>Recently experienced an outage of 6 days.</li>
                        <li>Customer was advised a price up of $10.</li>
                        <li>Looking for a service advisor to discuss service reliability and resolve bill $↑ and improve reliability.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div >

        <div className="p-1">
          <div className="grid grid-cols-5 gap-6 items-stretch">
            {/* Left Panel (Flags) */}
            <div className="col-span-1">
              <div className="bg-white shadow p-1 h-full text-sm flex flex-col justify-center items-center">
                <p> <strong>Call Flow</strong></p>

              </div>
            </div>

            {/* Middle Panel */}
            <div className="col-span-3 space-y-3">
              <div className="bg-white shadow p-1">
                <div className="flex">
                  <button className="text-black px-4 py-1 border-2 text-xs shadow" onClick={handleClick}>
                    Greet
                  </button>
                  <button className=" px-4 py-1 border-2 text-xs shadow" onClick={handleClick}>
                    Confirm Intent
                  </button>
                  <button className="bg-yellow-300 px-4 py-1 border-2 text-xs shadow" onClick={handleClick}>
                    Address
                  </button>
                  <button className="bg-green-400 px-4 py-1 border-2 text-xs shadow" onClick={handleClick}>
                    Upsell Fiber
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-1">
          <div className="grid grid-cols-5 gap-6 items-stretch">
            {/* Left Panel (Flags) */}
            <div className="col-span-1">
              <div className="bg-white shadow p-4 text-sm h-full flex flex-col justify-center items-center">
                <p> <strong>Actions</strong></p>

              </div>
            </div>

            {/* Middle Panel */}
            <div className="col-span-3 space-y-3">
              <div className="bg-white shadow p-1">
                <div className="space-y-1 text-xs max-h-40 overflow-y-auto pr-2">
                  <p>1. ✅ Greet Jane</p>
                  <p>2. ✅ Thank Jane for authentication</p>
                  <p>3. ! Confirm address</p>
                  <p>4. ❓ Ask about intent – billing question?</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-1">
          <div className="grid grid-cols-5 gap-6 items-stretch">
            {/* Left Panel (Title) */}
            <div className="col-span-1">
              <div className="bg-white shadow p-4 h-full text-sm flex flex-col justify-center items-center text-center min-h-[60px]">
                <p><strong>Recommended Script</strong></p>
              </div>
            </div>

            {/* Middle Panel */}
            <div className="col-span-3 space-y-3">
              <div className="bg-white shadow p-1">
                <div className="space-y-1 text-xs max-h-40 overflow-y-auto pr-2">
                  <p>I see you have pre-authenticated, thank you for that.</p>
                  <p className="mt-1">How can I help you today?</p>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div >
    </>

  );
};

export default AgentAssistUI;
